import React from "react";
import { Iconography } from "@hid-galaxy-ui/galaxy-react";
import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import {
  formatPartnerColumnLabel,
  PartnerColumnKey,
} from "./partnerListColumns";

type PartnerColumnsDropdownProps = {
  availableColumns: PartnerColumnKey[];
  visibleColumns: PartnerColumnKey[];
  onVisibleColumnsChange: (columns: PartnerColumnKey[]) => void;
};

const SelectIcon = (props: { className?: string }) => (
  <Iconography
    icon="angleDown"
    className={`partner-columns-select-icon ${props.className || ""}`}
  />
);

const PartnerColumnsDropdown: React.FC<PartnerColumnsDropdownProps> = ({
  availableColumns,
  visibleColumns,
  onVisibleColumnsChange,
}) => {
  return (
    <FormControl size="small" className="partner-columns-select-wrap">
      <Select
        multiple
        value={visibleColumns}
        onChange={(e) =>
          onVisibleColumnsChange(e.target.value as PartnerColumnKey[])
        }
        IconComponent={SelectIcon}
        displayEmpty
        renderValue={() => (
          <span className="partner-columns-select-value">
            <span className="vertical-bars" aria-hidden>
              <i />
              <i />
              <i />
            </span>
            <span>Columns</span>
          </span>
        )}
        className="partner-columns-select"
        MenuProps={{
          PaperProps: { className: "partner-columns-menu-paper" },
        }}
      >
        <MenuItem disableRipple disableTouchRipple className="partner-columns-menu-header">
          <span>Table Columns</span>
          <span className="menu-actions">
            <button
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onVisibleColumnsChange(availableColumns);
              }}
            >
              All
            </button>
            <button
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onVisibleColumnsChange([]);
              }}
            >
              None
            </button>
          </span>
        </MenuItem>

        {availableColumns.map((column) => (
          <MenuItem key={column} value={column}>
            <Checkbox checked={visibleColumns.includes(column)} />
            <ListItemText primary={formatPartnerColumnLabel(column)} />
          </MenuItem>
        ))}

        <MenuItem
          disableRipple
          disableTouchRipple
          className="partner-columns-menu-footer"
        >
          {visibleColumns.length} of {availableColumns.length} columns visible
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default PartnerColumnsDropdown;
